module.exports = __webpack_public_path__ + "img/activity01.b7ab6205.png";